import React from "react"
import { connect } from "react-redux";
import octopusFooterLogo from "../_resources/img/footerLogo.png";
import { Copyright } from "lucide-react";


export function Footer() {
    return (
        <footer className="footer-v2">
            <div className="footer-container">
                <p className="copyright-text">
                    <Copyright className="copyright-icon" />
                    <span>2026 Octopus Cybersecurity Inc. All rights reserved</span>
                </p>
                <img
                    src={octopusFooterLogo}
                    alt="Octopus Cybersecurity"
                    className="footer-logo"
                />
            </div>
        </footer>
    )
}

function mapStateToProps(state) {
    return { pageTitle: state.layout.pageTitle };
}

export default connect(mapStateToProps)(Footer);